import { mutatorAction } from "satcheljs";
import type GetBrandsSubscriptionsServiceResponse from "../store/schema/GetBrandsSubscriptionsServiceResponse";
import getBrandSubscriptionStoreForAccount from "../store/Store";
import type { MailboxInfo } from "owa-client-types";

const populateSubscriptionStoreMutator: (brandsSubscriptionsServiceResponse: GetBrandsSubscriptionsServiceResponse, mailboxInfo: MailboxInfo) => void = mutatorAction("populateSubscriptionStore", (brandsSubscriptionsServiceResponse: GetBrandsSubscriptionsServiceResponse, mailboxInfo: MailboxInfo): void => {
    const accountStore = getBrandSubscriptionStoreForAccount(mailboxInfo);
    
    for (const subscription of brandsSubscriptionsServiceResponse.subscriptions) {
        if (!subscription?.smtpInfo?.smtpAddress) {
            return;
        }
        
        accountStore.subscriptions.set(subscription.smtpInfo.smtpAddress.toLowerCase(), subscription);
    }
    
    for (const unsubscribedSubscription of brandsSubscriptionsServiceResponse.unsubscribedSubscriptions) {
        if (!unsubscribedSubscription?.smtpInfo?.smtpAddress) {
            return;
        }
        
        accountStore.unsubscribedSubscriptions.set(unsubscribedSubscription.smtpInfo.smtpAddress.toLowerCase(), unsubscribedSubscription);
    }
});
export default populateSubscriptionStoreMutator;
